(function () {
  var config = window.DIGGNIT_HEATMAP_CONFIG || {};
  var trackedPageTypes = {
    article: true,
    blog: true,
    cart: true,
    collection: true,
    index: true,
    page: true,
    product: true,
  };

  var pageType = String(config.pageType || '').toLowerCase();
  if (!config.enabled || !trackedPageTypes[pageType] || window.top !== window.self) {
    return;
  }

  var endpointBase = String(config.endpointBase || '').replace(/\/$/, '');
  if (!endpointBase) {
    return;
  }

  var apiUrl = endpointBase + '/_api/analytics/website-heatmap/collect';
  var queue = [];
  var flushTimer = null;
  var lastPointer = {
    timestamp: Date.now(),
    x: null,
    y: null,
  };

  function privacyAllowsTracking() {
    try {
      var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
      if (
        customerPrivacy &&
        typeof customerPrivacy.analyticsProcessingAllowed === 'function'
      ) {
        return Boolean(customerPrivacy.analyticsProcessingAllowed());
      }
    } catch (error) {}

    return true;
  }

  function getSessionId() {
    var storageKey = 'diggnit_heatmap_session_id';

    try {
      var existing = window.sessionStorage.getItem(storageKey);
      if (existing) {
        return existing;
      }

      var created =
        'hm_' +
        Date.now().toString(36) +
        '_' +
        Math.random().toString(36).slice(2, 10);
      window.sessionStorage.setItem(storageKey, created);
      return created;
    } catch (error) {
      return 'hm_' + Date.now().toString(36);
    }
  }

  function getDeviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;

    if (width < 768) {
      return 'mobile';
    }

    if (width < 1100) {
      return 'tablet';
    }

    return 'desktop';
  }

  function getDocumentHeight() {
    return Math.max(
      document.documentElement.scrollHeight || 0,
      document.body ? document.body.scrollHeight : 0,
      window.innerHeight || 0
    );
  }

  function normaliseText(value, fallback) {
    var collapsed = String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .slice(0, 120);

    return collapsed || (fallback || '');
  }

  function normaliseCoordinate(value) {
    if (!isFinite(value)) {
      return null;
    }

    if (value < 0) {
      return 0;
    }

    if (value >= 1) {
      return 0.999999;
    }

    return value;
  }

  function isInteractiveNode(node) {
    if (!node || !node.tagName) {
      return false;
    }

    var tagName = node.tagName.toLowerCase();
    return (
      tagName === 'a' ||
      tagName === 'button' ||
      tagName === 'summary' ||
      tagName === 'label' ||
      tagName === 'select' ||
      tagName === 'input' ||
      node.getAttribute('role') === 'button'
    );
  }

  function getEventElement(target) {
    if (!target) {
      return null;
    }

    if (target.nodeType === 1) {
      return target;
    }

    return target.parentElement || null;
  }

  function getSectionKey(target) {
    if (!target || !target.closest) {
      return '';
    }

    var labeledSection = target.closest('[data-heatmap-section]');
    if (labeledSection) {
      return normaliseText(labeledSection.getAttribute('data-heatmap-section'));
    }

    var shopifySection = target.closest('[id^="shopify-section-"]');
    if (shopifySection && shopifySection.id) {
      return normaliseText(
        shopifySection.id.replace(/^shopify-section-/, ''),
        'shopify-section'
      );
    }

    return '';
  }

  function getElementKey(target) {
    if (!target || !target.closest) {
      return '';
    }

    var labeledTarget = target.closest('[data-heatmap-area]');
    if (labeledTarget) {
      return normaliseText(labeledTarget.getAttribute('data-heatmap-area'));
    }

    var interactiveTarget = target.closest(
      'a, button, summary, input[type="submit"], input[type="button"], [role="button"]'
    );
    if (!interactiveTarget) {
      return '';
    }

    var ariaLabel = interactiveTarget.getAttribute('aria-label');
    if (ariaLabel) {
      return normaliseText(ariaLabel);
    }

    if (interactiveTarget.tagName.toLowerCase() === 'a' && interactiveTarget.getAttribute('href')) {
      return normaliseText('link:' + interactiveTarget.getAttribute('href'));
    }

    var textContent = normaliseText(interactiveTarget.textContent);
    if (textContent) {
      return textContent;
    }

    if (interactiveTarget.id) {
      return normaliseText('id:' + interactiveTarget.id);
    }

    return interactiveTarget.tagName.toLowerCase();
  }

  function queueEvent(event) {
    if (!privacyAllowsTracking()) {
      return;
    }

    queue.push(event);
    if (queue.length >= 12) {
      flush(false);
      return;
    }

    if (!flushTimer) {
      flushTimer = window.setTimeout(function () {
        flush(false);
      }, 5000);
    }
  }

  function flush(useBeacon) {
    if (!queue.length) {
      return;
    }

    if (flushTimer) {
      window.clearTimeout(flushTimer);
      flushTimer = null;
    }

    var payload = JSON.stringify({
      deviceType: getDeviceType(),
      documentHeight: getDocumentHeight(),
      events: queue.splice(0, queue.length),
      locale: normaliseText(config.locale || document.documentElement.lang || 'en', 'en'),
      pagePath: window.location.pathname || '/',
      pageTitle: document.title || '',
      pageType: pageType || 'unknown',
      pageUrl: window.location.href,
      sessionId: getSessionId(),
      siteKey: normaliseText(config.siteKey || window.location.hostname, window.location.hostname),
      viewportHeight: window.innerHeight || document.documentElement.clientHeight || 0,
      viewportWidth: window.innerWidth || document.documentElement.clientWidth || 0,
    });

    if (useBeacon && navigator.sendBeacon) {
      try {
        var blob = new Blob([payload], {
          type: 'text/plain;charset=UTF-8',
        });
        if (navigator.sendBeacon(apiUrl, blob)) {
          return;
        }
      } catch (error) {}
    }

    fetch(apiUrl, {
      body: payload,
      headers: {
        'Content-Type': 'text/plain;charset=UTF-8',
      },
      keepalive: true,
      method: 'POST',
      mode: 'cors',
    }).catch(function () {});
  }

  function trackPageView() {
    queueEvent({
      timestamp: Date.now(),
      type: 'page_view',
    });
  }

  function handleClick(event) {
    if (!event.isTrusted || !privacyAllowsTracking()) {
      return;
    }

    var target = getEventElement(event.target);
    if (!isInteractiveNode(target) && !(target && target.closest)) {
      return;
    }

    var interactiveTarget = isInteractiveNode(target)
      ? target
      : target.closest(
          'a, button, summary, input[type="submit"], input[type="button"], [role="button"]'
        );

    if (!interactiveTarget) {
      return;
    }

    queueEvent({
      elementKey: getElementKey(interactiveTarget),
      sectionKey: getSectionKey(interactiveTarget),
      timestamp: Date.now(),
      type: 'click',
      x: normaliseCoordinate(
        (event.clientX + window.scrollX) / Math.max(window.innerWidth || 1, 1)
      ),
      y: normaliseCoordinate(
        (event.clientY + window.scrollY) / Math.max(getDocumentHeight(), 1)
      ),
    });
  }

  function handlePointerMove(event) {
    if (!privacyAllowsTracking() || getDeviceType() === 'mobile') {
      return;
    }

    if (event.pointerType && event.pointerType !== 'mouse') {
      return;
    }

    var now = Date.now();
    var normalisedX = normaliseCoordinate(
      (event.clientX + window.scrollX) / Math.max(window.innerWidth || 1, 1)
    );
    var normalisedY = normaliseCoordinate(
      (event.clientY + window.scrollY) / Math.max(getDocumentHeight(), 1)
    );

    if (normalisedX === null || normalisedY === null) {
      return;
    }

    if (lastPointer.x !== null && lastPointer.y !== null) {
      var dx = Math.abs(normalisedX - lastPointer.x);
      var dy = Math.abs(normalisedY - lastPointer.y);
      var dwellMs = now - lastPointer.timestamp;

      if (dwellMs < 350 && dx + dy < 0.025) {
        return;
      }

      queueEvent({
        dwellMs: Math.max(0, Math.min(4000, dwellMs)),
        sectionKey: getSectionKey(getEventElement(event.target)),
        timestamp: now,
        type: 'pointer_sample',
        x: normalisedX,
        y: normalisedY,
      });
    }

    lastPointer.x = normalisedX;
    lastPointer.y = normalisedY;
    lastPointer.timestamp = now;
  }

  if (!privacyAllowsTracking()) {
    return;
  }

  trackPageView();

  document.addEventListener('click', handleClick, true);
  document.addEventListener('pointermove', handlePointerMove, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      flush(true);
    }
  });
  window.addEventListener('pagehide', function () {
    flush(true);
  });
})();